import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'smileyReplace'
})

export class SmileyReplacePipe implements PipeTransform {
    transform(value: string): any {
      if (!value || value === '-1') {
        return '';
      }
      const myRegex = /(\(groen\))|(\(rood\))|(\(oranje\))/g;
      const progressEmoji = {
        '(rood)': '/assets/img/icon-smiley-red.svg',
        '(oranje)': '/assets/img/icon-smiley-orange.svg',
        '(groen)': '/assets/img/icon-smiley-green.svg'
      };


      return value.replace(new RegExp(myRegex, 'gi'), (s) => {
        return  `<img src="${progressEmoji[s]}"/>`;
      });
    }
}



// WEBPACK FOOTER //
// ./src/app/pipes/smileyReplace.pipe.ts